/*eslint-disable */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import timeZoneData from '../../data/timeZoneData.json';
/**
 * The following code is extracted from moment-timezone@0.5.30 to unpack
 * moment-timezones's time-zone data and shape it the way Globalize needs it.
 *
 * As the sdk does not rely on moment and we don't want to include it as a dependency (it's huge!),
 * we just bring the code that is necessary to read the data that is packed in a very specific way
 * to reduce the overall size of the json that is shipped to production.
 *
 * Example usage:
 *
 * import Globalize from 'globalize';
 * import {getTimeZoneData} from '@stripe-internal/cldr';
 *
 * Globalize.loadTimeZone(
 *   getTimeZoneData('Europe/Madrid)
 * );
 */ /************************************
  Unpacking
************************************/ function charCodeToInt(charCode) {
    if (charCode > 96) {
        return charCode - 87;
    } else if (charCode > 64) {
        return charCode - 29;
    }
    return charCode - 48;
}
function unpackBase60(string) {
    let i = 0;
    const parts = string.split('.');
    const whole = parts[0];
    const fractional = parts[1] || '';
    let multiplier = 1;
    let num;
    let out = 0;
    let sign = 1;
    // handle negative numbers
    if (string.charCodeAt(0) === 45) {
        i = 1;
        sign = -1;
    }
    // handle digits before the decimal
    for(i; i < whole.length; i++){
        num = charCodeToInt(whole.charCodeAt(i));
        out = 60 * out + num;
    }
    // handle digits after the decimal
    for(i = 0; i < fractional.length; i++){
        multiplier /= 60;
        num = charCodeToInt(fractional.charCodeAt(i));
        out += num * multiplier;
    }
    return out * sign;
}
function arrayToInt(array) {
    for(let i = 0; i < array.length; i++){
        array[i] = unpackBase60(array[i]);
    }
}
function intToUntil(array, length) {
    for(let i = 0; i < length; i++){
        array[i] = Math.round((+array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
    }
    array[length - 1] = Infinity;
}
function mapIndices(source, indices) {
    const out = [];
    for(let i = 0; i < indices.length; i++){
        out[i] = source[indices[i]];
    }
    return out;
}
function unpack(string) {
    const data = string.split('|');
    const offsets = data[2].split(' ');
    const indices = data[3].split('');
    const untils = data[4].split(' ');
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    const population = data[5] | 0;
    arrayToInt(offsets);
    arrayToInt(indices);
    arrayToInt(untils);
    intToUntil(untils, indices.length);
    return {
        name: data[0],
        abbrs: mapIndices(data[1].split(' '), indices),
        offsets: mapIndices(offsets, indices),
        untils,
        population
    };
}
/** **********************************
  Reading
*********************************** */ const zones = {};
const links = {};
const names = {};
const guesses = {};
const isdsts = {};
function normalizeName(name) {
    return (name || '').toLowerCase().replace(/\//g, '_');
}
function addZone(packed) {
    let i;
    let name;
    let split;
    let normalized;
    if (typeof packed === 'string') {
        // eslint-disable-next-line no-param-reassign
        packed = [
            packed
        ];
    }
    for(i = 0; i < packed.length; i++){
        split = packed[i].split('|');
        // eslint-disable-next-line prefer-destructuring
        name = split[0];
        normalized = normalizeName(name);
        zones[normalized] = packed[i];
        names[normalized] = name;
        addToGuesses(normalized, split[2].split(' '));
    }
}
function addLink(aliases) {
    let i;
    let alias;
    let normal0;
    let normal1;
    if (typeof aliases === 'string') {
        // eslint-disable-next-line no-param-reassign
        aliases = [
            aliases
        ];
    }
    for(i = 0; i < aliases.length; i++){
        alias = aliases[i].split('|');
        normal0 = normalizeName(alias[0]);
        normal1 = normalizeName(alias[1]);
        links[normal0] = normal1;
        // eslint-disable-next-line no-param-reassign, prefer-destructuring
        names[normal0] = alias[0];
        links[normal1] = normal0;
        // eslint-disable-next-line no-param-reassign, prefer-destructuring
        names[normal1] = alias[1];
    }
}
function addToGuesses(name, offsets) {
    let i;
    let offset;
    arrayToInt(offsets);
    for(i = 0; i < offsets.length; i++){
        offset = offsets[i];
        guesses[offset] = guesses[offset] || {};
        guesses[offset][name] = true;
    }
}
function getZone(name, caller) {
    // eslint-disable-next-line no-param-reassign
    name = normalizeName(name);
    let zone = zones[name];
    let link;
    if (typeof zone === 'object') {
        return zone;
    }
    if (typeof zone === 'string') {
        zone = unpack(zone);
        zones[name] = zone;
        return zone;
    }
    // Pass getZone to prevent recursion more than 1 level deep
    if (links[name] && caller !== getZone && // eslint-disable-next-line no-cond-assign
    (link = getZone(links[name], getZone))) {
        // eslint-disable-next-line no-multi-assign
        zone = zones[name] = Object.assign({}, link);
        zone.name = names[name];
        return zone;
    }
    return null;
}
function addIsdsts(packed) {
    packed.forEach((p)=>{
        const split = p.split('|');
        const name = split[0];
        const isdstsPacked = split[1];
        const normalized = normalizeName(name);
        isdsts[normalized] = isdstsPacked.split('').map(Number);
    });
}
function set(obj, path, value) {
    const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
    if (!pathArray) {
        return obj;
    }
    Array.from(pathArray).reduce((acc, key, i)=>{
        if (acc[key] === undefined) acc[key] = {};
        if (i === pathArray.length - 1) acc[key] = value;
        return acc[key];
    }, obj);
    return obj;
}
addZone(timeZoneData.zones);
addLink(timeZoneData.links);
addIsdsts(timeZoneData.isdsts);
export default function getZoneData(zoneName) {
    const originalZone = getZone(zoneName);
    if (!originalZone) {
        return null;
    }
    const name = normalizeName(originalZone.name);
    return {
        zoneData: set({}, (originalZone.name || '').replace(/\//g, '.'), _object_spread_props(_object_spread({}, originalZone), {
            isdsts: isdsts[name] || isdsts[links[name]]
        }))
    };
}

//# sourceMappingURL=getTimeZoneData.js.map